import { render } from "./SolicitudesInspeccionComponent.vue?vue&type=template&id=05cc6fea"
import script from "./SolicitudesInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./SolicitudesInspeccionComponent.vue?vue&type=script&lang=js"

import "./SolicitudesInspeccionComponent.vue?vue&type=style&index=0&id=05cc6fea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__